import React from 'react';

export const DeleteByPeriodModal = ({
  visible,
  onClose,
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  minDate,
  maxDate,
  dateError,
  onSubmit,
  deleting,
  t,
}) => {
  if (!visible) return null;

  const isValidRange = startDate && endDate && endDate >= startDate;

  return (
    <div className="modal task" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modalclose" onClick={onClose}>&times;</span>
          <h2>{t('conversation.deleteByPeriodTitle')}</h2>
        </div>
        <div className="modal-form d-flex flex-row flex-wrap">
          <div className="form-row col-half row-date">
            <label>{t('conversation.periodStart')}</label>
            <input
              type="date"
              className={dateError?.start ? 'invalid' : ''}
              value={startDate}
              min={minDate}
              max={maxDate}
              onChange={(e) => onStartChange(e.target.value)}
            />
            {dateError?.start && <div className="error">{dateError.start}</div>}
          </div>
          <div className="form-row col-half row-date">
            <label>{t('conversation.periodEnd')}</label>
            <input
              type="date"
              className={dateError?.end ? 'invalid' : ''}
              value={endDate}
              min={startDate || minDate}
              max={maxDate}
              onChange={(e) => onEndChange(e.target.value)}
            />
            {dateError?.end && <div className="error">{dateError.end}</div>}
          </div>
          <div className="form-row col-full row-actions">
            <button type="button" className="button button-large" onClick={onClose}>
              {t('common.cancel')}
            </button>
            <button
              type="button"
              className="button button-large button-blue"
              disabled={!isValidRange || deleting}
              onClick={onSubmit}
            >
              {deleting ? t('common.processing') : t('common.delete')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
